import React from 'react'
import ModalWrapper from '../ModalWrapper'
import GoogleAccountAuthenticationContainer from '../../../containers/account/GoogleAccountAuthenticationContainer'

const GoogleAccountAuthenticationModal= props => {


	return (
		<div className='accountAuthentication-modal'>
			<ModalWrapper
				{...props}
				title={(props.googleUser ? 'Add Google Sign-in' : 'Google Sign-in')}
				iconName='googleLogo'
				modalStyle='light'
				closeBtn={false}
			>
			<GoogleAccountAuthenticationContainer {...props} />
	</ModalWrapper>
	</div>
	)
}

export default GoogleAccountAuthenticationModal